import Vue from 'vue'
import Vuex from 'vuex'

import win from './store/win'
import pop from './store/pop'
import gallery from './store/gallery'

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		win,
		pop,
		gallery
	},
	state: {
		gallery: [],
		gps: null, // {vehicle_id, from, to}

		windows: [],

		hover: null,
		hoverAlign: 'left',
		hoverType: null,
		update: 0,
		app: null,
		windowStack: null,
		popupController: null,
		auth: null,
		user: {
			id: null,
			name: '',
			_embedded: {
				roles: []
			}
		},
		departments: [],
		department: {
			id: null,
			label: ''
		}
	},
	mutations: {
		gallery(state, images) {
			state.gallery = images;
		},

		gps(state, gps) {
			state.gps = gps;
		},

		hover(state, pl) {
			state.hover = pl[0];
			state.hoverAlign = pl[1];
			state.hoverType = pl[2];

			console.log('hover set', pl);
		},
		increment(state) {
			state.count++
		},

		user(state, user) {
			state.user = user;

			// Store as well
		},

		departments(state, departments) {
			state.departments = departments;
		},

		department(state, department) {
			state.department = department;
		},

		update(state) {
			state.update++;
		},

		auth(state, auth) {
			state.auth = auth;
		}
	}
});